import { render, staticRenderFns } from "./OnHoldPopup.vue?vue&type=template&id=39f4f128&scoped=true&"
import script from "./OnHoldPopup.vue?vue&type=script&lang=js&"
export * from "./OnHoldPopup.vue?vue&type=script&lang=js&"
import style0 from "./OnHoldPopup.vue?vue&type=style&index=0&id=39f4f128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4f128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
